import { Tooltip, TooltipContent, TooltipTrigger } from '@quadminds/mindkit';
import * as Portal from '@radix-ui/react-portal';
import { HelpCircle } from 'lucide-react';

const TooltipFilePermission = () => {
    return (
        <Tooltip>
            <TooltipTrigger>
                <HelpCircle size={20} className="text-gray-400" aria-label="Ayuda" />
            </TooltipTrigger>
            <Portal.Root>
                <TooltipContent
                    side="right"
                    className="text-md bg-background shadow-lg border border-border max-w-lg w-[400px] z-[9999]"
                >
                    <div className="mb-2">
                        <span className="font-semibold font-poppins">Consulta: </span>
                        <span className="text-muted-foreground">
                            Permite que Mindy use el archivo para responder preguntas del usuario.
                        </span>
                    </div>
                    <div className="mb-2">
                        <span className="font-semibold font-poppins">Exploración: </span>
                        <span className="text-muted-foreground">
                            Permite acceder a la sección de Conocimiento y visualizar nombres y carpetas de archivos.
                        </span>
                    </div>
                    <div className="mb-2">
                        <span className="font-semibold font-poppins">Gestión: </span>
                        <span className="text-muted-foreground">
                            Permite activar o desactivar archivos, moverlos o cambiarles el nombre.
                        </span>
                    </div>
                    <div>
                        <span className="font-semibold font-poppins">Administración: </span>
                        <span className="text-muted-foreground">
                            Permite asignar o quitar permisos y eliminar archivos.
                        </span>
                    </div>
                </TooltipContent>
            </Portal.Root>
        </Tooltip>
    );
};

export default TooltipFilePermission;
